import { ArticleHeading4, TooltipDesktop, UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PromotionDescription.css';
import { IVas } from '../../types/vas';
import { ContentRow } from '../ContentRow';

type TPromotionDescriptionProps = {
  promotionDescription: string;
  isPerformanceVasPilot: boolean;
  item: IVas[];
  isBet: boolean;
  isCpcOffer: boolean;
};

export const PromotionDescription = ({
  item,
  promotionDescription,
  isBet,
  isPerformanceVasPilot,
  isCpcOffer,
}: TPromotionDescriptionProps) => {
  if (isCpcOffer) {
    return (
      <div data-testid="promotionDescription" className={styles['wrapper']}>
        <UIText2 fontWeight="bold" color="text-warning-default">
          {promotionDescription}
        </UIText2>
      </div>
    );
  }

  return (
    <div data-testid="promotionDescription" className={styles['wrapper']}>
      {(isPerformanceVasPilot && !isBet) || !item.length ? (
        <UIText2 fontWeight="bold" color="text-warning-default">
          {promotionDescription}
        </UIText2>
      ) : (
        <TooltipDesktop
          theme="white"
          placement="top-end"
          title={
            <>
              <ContentRow size="M">
                <ArticleHeading4>Действуют услуги</ArticleHeading4>
              </ContentRow>
              {item.map(vas => (
                <ContentRow size="M" key={`vas-${vas.type}`}>
                  <UIHeading5 color="text-warning-default" fontWeight="bold">
                    {vas.name}
                  </UIHeading5>
                  <UIText2>{vas.description}</UIText2>
                </ContentRow>
              ))}
              <a href="https://support.cian.ru/ru/knowledge_base/art/94/cat/179/" target="_blank" rel="noreferrer">
                Узнать подробнее
              </a>
            </>
          }
        >
          <UIText2 fontWeight="bold" color="text-warning-default">
            {promotionDescription}
          </UIText2>
        </TooltipDesktop>
      )}
    </div>
  );
};
